import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserPageTitle } from '@shared/constants/browser-page-title.enum';

import { MakePaymentPage } from './make-payment.page';

const routes: Routes = [
  {
    path: '',
    component: MakePaymentPage,
    data: { title: BrowserPageTitle.makePayment },
  },
  {
    path: 'adjust-payment',
    loadChildren: () =>
      import('../adjust-payment/adjust-payment.module').then(
        m => m.AdjustPaymentPageModule,
      ),
  },
  {
    path: 'review-payment',
    loadChildren: () =>
      import('../review-payment/review-payment.module').then(
        m => m.ReviewPaymentPageModule,
      ),
  },
  {
    path: 'payment-confirmation',
    loadChildren: () =>
      import('../payment-confirmation/payment-confirmation.module').then(
        m => m.PaymentConfirmationPageModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MakePaymentPageRoutingModule {}
